window.initReveal = function () {
  var hasOverlay = document.querySelector('.reveal--overlay, .reveal--overlayMobile, .reveal--drawerLeft, .reveal--drawerRight');

  if (hasOverlay) {
    if (!window.revealScript) {
      var script = window.revealScript = document.createElement('script');
      script.src = '/files/bodyScrollLock.min.js';
      script.defer = true;
      script.async = true;
      script.onload = window.cbReveal;
      document.head.appendChild(script);
    } else {
      window.cbReveal();
    }
  }
}

window.cbReveal = function () {
  bodyScrollLock.clearAllBodyScrollLocks();
  var overlays = document.querySelectorAll('.reveal--overlay, .reveal--overlayMobile, .reveal--drawerLeft, .reveal--drawerRight');

  for (var i = 0; i < overlays.length; i++) {
    var controller = overlays[i].querySelector('.reveal__controller');
    controller.addEventListener('change', onChangeController);
  }

  function onChangeController(event) {
    var parentNode = event.target.parentNode;
    for (var i = 0; i < overlays.length; i++) {
      if (overlays[i] !== parentNode) {
        overlays[i].querySelector('.reveal__controller').checked = false;
        overlays[i].parentNode.classList.remove('masthead__exterior--active');
      }
    }

    if (parentNode.parentNode.classList.contains('masthead__exterior')) {
      parentNode.parentNode.classList.add('masthead__exterior--active');
      if (event.target.checked) {
        // hide logo siteName when navigation is opened
        document.querySelector('#LogoCurrentSiteName').style.visibility = 'hidden';
      } else {
        // show logo siteName when navigation is opened
        document.querySelector('#LogoCurrentSiteName').style.visibility = 'initial';
      }
    }

    var panel = parentNode.querySelector('.reveal__panel');
    if (event.target.checked) {
      bodyScrollLock.disableBodyScroll(panel);
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  }
}

/** get in call stack **/
setTimeout(function() {
  initReveal();
}, 100 );